import { type TermLifeStepParams, whoBenefitsSchema } from '@flows/configs/de/termLife/steps/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const WHO_BENEFITS_KEYS = [
  'partner',
  'kids',
  'parents',
  'family_abroad',
  'business_partner',
  'other',
]

export const whoBenefits = (params: TermLifeStepParams) => {
  const schema = whoBenefitsSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_termLife:steps.who_benefits.title',
        },
      },
      {
        type: 'checkbox',
        name: params.helperFunctions.getParamPath('who_benefits'),
        fields: WHO_BENEFITS_KEYS.map((option) => ({
          name: params.helperFunctions.getParamPath(`who_benefits.${option}`),
          title: {
            type: 'translatableText',
            translationKey: `sharedFlows_termLife:steps.who_benefits.options.${option}`,
          },
        })),
        shouldTrackValues: true,
      },
    ],
    nextStep: 'loan',
    subFlow: SubFlow.TermLife,
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
  } as const satisfies AnyStepConfiguration
}
